import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter, Link } from 'react-router-dom';
import ReactWOW from 'react-wow';

import {
  Row,
  Col,
} from 'reactstrap';

class OurAchievements2 extends Component {
  static propTypes = {
  };

  static defaultProps = {
    user: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      salesValue: 15000,
      commission: 15,
      fees: 1000,
    };
  }

  componentDidMount() {
    const { user } = this.props;

  }

  render() {
    const { user } = this.props;
    const {
      salesValue, fees, commission,
    } = this.state;

    return (
      <>
        <section className="our-achievement our-achievement2 section">
          <div className="container">
            <ReactWOW animation='fadeInUp' delay=".4s">
              <div className="section-title">
                <h2 className="wow fadeInUp blue-h2" data-wow-delay=".4s"></h2>
              </div>
              <div className="row">
                <Col xs="12">
                  <div className="our-achievement2-text">
                    <b>Gift Card Market Continues to Grow:</b> +11% in 2024, despite economic uncertainty
                  </div>
                  <div className="our-achievement2-text">
                    <b>Digital Gift Cards Now Dominate:</b> Over 50% market share in 2024
                  </div>
                  <div className="our-achievement2-text-quote">
                    <b>(UK GCVA Statistics)</b>
                  </div>
                  <div className="our-achievement2-text">
                    Gift cards support businesses by driving revenue, expanding marketing reach, increasing customer choice, and boosting brand recognition.
                  </div>
                </Col>
              </div>
            </ReactWOW>
            </div>
        </section>
      </>
    );
  }
}

export default withRouter(OurAchievements2);








